// NPT-1983: traveller-facing support mailbox. `supportEmail` wins; when it is blank or absent (a new
// site not yet configured, or an API that predates the field) fall back to `email`, matching npt-api.
export const getSupportEmail = (site?: { supportEmail?: string | null; email?: string | null } | null): string =>
   site?.supportEmail?.trim() || site?.email?.trim() || '';
